import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class PaymentOrdersSentIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordens/pagamentos/enviadas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/ordem/pagamento/editar/' + cell;
    
    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-xs button-inline'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        <button className="btn btn-danger btn-xs button-inline" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var contract_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/cliente/' + contract_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(contract_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(contract_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == contract_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  export(event) {
    var url = event.currentTarget.value;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.titulo}</h3>
      <Link to="/ordem/pagamento/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.botaoAdicionarOrdemDePagamento}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.semFornecedoresCadastrados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.Codigo}</TableHeaderColumn>
        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="created" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.DataDeCriacao}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.OrdensDePagamento.ListaDeOrdensDePagamentoEnviadas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentOrdersSentIndex;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/PaymentOrdersSentIndex.js